import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * SettingsSectionNav
 *
 * A vertical tab nav used inside sub-sections (Identity, Config).
 * Highlights the item whose path matches the current route.
 *
 * Props:
 *   items – Array of { path: string, label: string, icon?: LucideComponent }
 */
const SettingsSectionNav = ({ items }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="flex flex-col gap-0.5">
      {items.map((item) => {
        const active =
          pathname === item.path || pathname.startsWith(item.path + "/");
        const Icon = item.icon;

        return (
          <button
            key={item.path}
            type="button"
            aria-current={active ? "page" : undefined}
            onClick={() => navigate(item.path)}
            className={`photon-settings-nav relative flex items-center gap-2.5 px-3 py-2 rounded-lg text-xs transition-colors duration-150 text-left w-full ${
              active
                ? "bg-fill-indigo-50 dark:bg-fill-primary/15 text-ink-primary dark:text-ink-accent font-medium"
                : "text-ink-gray-500 dark:text-ink-gray-400 hover:bg-fill-gray-100 dark:hover:bg-fill-dialog-border hover:text-ink-ink dark:hover:text-ink-white"
            }`}
          >
            <AnimatePresence>
              {active && (
                <motion.span
                  layoutId="section-nav-indicator"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-5 bg-fill-primary dark:bg-fill-accent rounded-full"
                />
              )}
            </AnimatePresence>
            {Icon && <Icon className="w-3.5 h-3.5 flex-shrink-0" />}
            <span className="truncate">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default SettingsSectionNav;
